import * as React from 'react';
import { connect } from 'react-redux';
import InvoiceForm from '../../forms/invoiceForm';

//import styles from './styles';
import { SafeAreaView, Linking, Platform } from 'react-native';
import { Container, Header, Content, Text, Label, Item, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title, Footer } from 'native-base';

import * as _ from 'lodash';
import Modal from '../../components/modal';
import CalCalDataApi from '../../api/CalCalDataApi';
import XDate from 'xdate';
import styles from './styles';
import { formValueSelector, change, arrayPush, arrayRemove, SubmissionError } from 'redux-form';
import diff from 'object-diff';
import sharer from '../../components/sharer';
import { deleteTrans } from '../DailyEntries/actions';
import CustomerSelect from './customerSelect';

//import stylesheet from '../../components/tcomb-styles';
//form options for receipt and takings forms?
//Get the entry from appropriate thingy (and make it load as necessary)
import PersonForm from '../PersonForm';
import InvoiceItemForm from '../../forms/invoiceItemForm';
import Alert from '../../components/alert';
import KeyHandler from '../../components/keyHandler';

import { updateCustomerDebt } from '../People/actions';
import downloader from '../../components/downloader';

//Redux-form: https://medium.com/wolox-driving-innovation/https-medium-com-wolox-driving-innovation-easy-forms-in-react-native-with-redux-form-1cdc16a9a889
//Picker https://github.com/GeekyAnts/NativeBase/issues/349

class InvoiceFormContainer extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {
			isLoading: true,
			isError: false,
			data: [],
			//options: this._getFormOptions(),
			formLoaded: false,
			adding: false,
			isSaving: false,
			isSharing: false,
			editingCust: false,
			editingItem: false
		};
		this.state = this.initialState;
	}

	componentDidMount() {
		const params = this.props.route?.params || {};
		var { id, copyId } = params;

		if (id) {
			this.loadTransaction(id);
		} else if (copyId) {
			this.copyTransaction(copyId);
		} else {
			const zero = '0.00';
			const expenseDate = params.addDate || new Date().toISOString().split('T')[0];
			const customer_id = params.customer_id;
			const invoice_id = params.type && params.type == 'credit' ? -1 : 0;
			const type = invoice_id == -1 ? 'Credit Note' : 'Invoice';
			const entry = params.entry || {
				expenseDate,
				net: zero,
				payable: zero,
				takingCategory_id: '0',
				account_id: '4',
				paid: zero,
				vat: zero,
				customer_id,
				items: [],
				invoice_status: 'draft',
				invoice_id
			};
			this.setState({ adding: true, entry, type });
		}
	}

	/*componentWillReceiveProps(nextProps){
		console.log('cont nextProps.customers',nextProps.customers)
	}*/

	shouldComponentUpdate(nextProps, nextState) {
		//if(nextProps.customers!=this.props.customers || nextProps.suppliers!=this.props.suppliers) return true
		//if(nextState != this.state) return true;
		/*if(nextProps.formVals != this.props.formVals){ //being careful on formVals change
			if(!this.state.showAccts && nextProps.formVals.paid && parseFloat(nextProps.formVals.paid)>0) this.setState({showAccts:true});
			if(this.state.showAccts && nextProps.formVals.paid && parseFloat(nextProps.formVals.paid)==0) this.setState({showAccts:false});
			return false;
		}*/
		//console.log('formVals', this.props.formVals);
		//var propsNext = nextProps;
		//delete propsNext.formVals.items;
		//if(propsNext == this.props && this.state == nextState) return false;
		//we do not need to refresh when just items changes
		if (
			this.state == nextState &&
			this.state.isSaving == nextState.isSaving &&
			nextProps.formVals.paid == this.props.formVals.paid &&
			nextProps.formVals.invoice_status == this.props.formVals.invoice_status
		) {
			if (nextProps.formVals.items != this.props.formVals.items) {
				this.recalcTotals();
				console.log('recalc totals');
			}
			//console.log('NOOOOOTT   Invoice Cont refresh', nextProps.formVals);

			return false;
		}
		//console.log('Invoice Cont refresh', diff(this.state, nextState), diff(this.props, nextProps));
		return true;
	}

	async loadTransaction(id) {
		//no need for redux. Just one transaction; load it
		__DEV__ && console.log('loading for ', id);
		var path = 'invoice/' + id;

		CalCalDataApi.dataLoad(path, this.props.jwt, res => {
			if (res) {
				//console.log(res);
				const type = res.payable < 0 ? 'Credit Note' : 'Invoice';
				this.setState({ entry: res, type });
			} else {
				this.setState({ isError: true });
			}
		});
	}

	copyTransaction(id) {
		var path = 'invoice/' + id;
		CalCalDataApi.dataLoad(path, this.props.jwt, res => {
			if (!res.error) {
				delete res.id;
				delete res.setransaction_id;
				delete res.receipt_ref;
				delete res.asset_id;
				delete res.invoiceHtml;
				delete res.invoiceNo;
				delete res.series_id;
				delete res.series_freq;
				delete res.description;
				res.invoice_status = 'draft';
				res.expenseDate = new Date().toISOString().split('T')[0];
				var items = res.items.map((item, i) => {
					delete item.id;
					delete item.invoice_id;
					return item;
				});
				res.items = items;
				const type = res.payable < 0 ? 'Credit Note' : 'Invoice';
				res.invoice_id = res.payable < 0 ? -1 : 0;
				this.setState({ adding: true, entry: res, type });
			} else {
				this.setState({ isError: res.error });
			}
		});
	}

	async saveRecord(exit = true) {
		this.setState({ isSaving: true });
		let errors = await this.refs.form.submit();
		//etc - set states and return errors
		this.setState({ isSaving: false });
		console.log('errors', errors);
		if (!errors) {
			console.log('Submit ok, Going back');
			exit && this.props.navigation.goBack();
			return false;
		} else {
			return errors;
		}
	}

	promisedSetState = newState => {
		return new Promise(resolve => {
			this.setState(newState, () => {
				resolve();
			});
		});
	};

	async download(noAsk = false) {
		if (!noAsk && this.state.entry && this.state.entry.invoice_status == 'draft') return this.askIfSend(this.download.bind(this));
		await this.promisedSetState({ isSharing: true });
		const problem = await this.saveRecord(false);
		if (problem) {
			console.log('save error', problem);
			this.setState({ isSharing: false });
			return false; //and say something!
		}
		CalCalDataApi.dataInsert(`invoice/PDF/${this.state.entry.id}`, { base64: true }, this.props.jwt, res => {
			//console.log('invdown ', res);
			this.setState({ isSharing: false });

			downloader(res.content, res.file);
		});
	}
	async share(noAsk = false) {
		if (!noAsk && this.state.entry && this.state.entry.invoice_status == 'draft') return this.askIfSend(this.share.bind(this));
		console.log('setting Saving');
		await this.promisedSetState({ isSharing: true });
		const problem = await this.saveRecord(false);
		if (problem) {
			console.log('save error', problem);
			this.setState({ isSharing: false });
			return false; //and say something!
		}
		CalCalDataApi.dataInsert(`invoice/PDF/${this.state.entry.id}`, { base64: true }, this.props.jwt, res => {
			//console.log('invoice ', res);
			this.setState({ isSharing: false });
			//const url = res.filename;
			if (res.content) {
				const base64Data = `data:application/pdf;base64,` + res.content;
				sharer(res.content, res.file, res.filename);
			}
		});
	}

	changeStatus(toStatus) {
		this._changeFormVal('invoice_status', toStatus);
		//this.state.entry.invoice_status = toStatus; //dont re-render; we would lose form vals
		//console.log(this.state.entry);
	}

	askIfSend(callback) {
		//console.log(arguments);
		Alert.alert('Mark ' + this.state.type + ' as sent?', 'This will close the invoice and prevent further changes.', [
			{ text: 'No', onPress: () => callback(true) },
			{
				text: 'Yes',
				onPress: () => {
					this.changeStatus('sent');
					setTimeout(() => callback(true), 300);
				}
			}
		]);
	}

	handleSubmit(values) {
		//return false if no errors
		delete values.undefined;

		if (this.state.entry.id) {
			var difference = diff(this.state.entry, values); //added, deleted, changed, updated (arrays)
			__DEV__ && console.log('diff:', difference, Object.keys(difference).length);
			if (Object.keys(difference).length == 0) return false;
			difference.id = this.state.entry.id; //send the id down to store!

			difference.items = values.items;
			var storeDiffs = {};
			if (difference.customer_id) storeDiffs.name = _.find(this.props.customers, ['id', difference.customer_id]).display; //hack to keep 'display' in dailyEntries/
			if (difference.expenseCategory_id) storeDiffs.name = _.find(this.props.expenseCategories, ['id', difference.expenseCategory_id]).categoryName;
			//console.log('SUBITTing', difference, values, this.state.entry);
			return CalCalDataApi.dataUpdate('invoice/' + this.state.entry.id, difference, this.props.jwt, res => {
				if (values.payable == '0.00') {
					Alert.alert('Total is zero', this.state.type + ' will be void or deleted');
					this.onDeleteTrans(this.state.entry);
					return false;
				}

				//console.log('handleSubmit ', res);
				if (res && res.id) {
					this.props.dispatch({
						type: 'UPDATE/dailyEntry', //successful update send UPDATE(d) to store
						id: this.state.entry.id,
						difference: res, //Whole thing as difference!
						origDate: this.state.entry.expenseDate,
						storeDiffs
					});
					if (res.customer_id) this.props.dispatch(updateCustomerDebt(res.customer_id));
					return false;
				} else if (res.validationErrors) {
					console.log('validationErrors ', res.validationErrors);
					throw new SubmissionError(res.validationErrors);
				} else {
					message = res.statusText || res.message;
					console.log('fail', res, message);
					Alert.alert('Save failed, error ' + res.status + ': ' + message);
					throw new SubmissionError(res.title);
				}
			});
		} else {
			//NEW
			//if total is zero refuse to save
			if (values.payable == '0.00') return Alert.alert('Total is zero', 'Add some items / labour, or cancel') || { notes: 'no' };
			__DEV__ && console.log('SUBITTing', values);
			return CalCalDataApi.dataInsert('invoice', values, this.props.jwt, res => {
				//console.log('handleSubmit ', res);
				if (res.id) {
					//this.insertId = res.id.toString()+this.transType=='receipt'?'1':'2'; //hard coded here for offline compat
					this.props.dispatch({
						type: 'INSERT/dailyEntry', //successful update send UPDATE(d) to store
						entry: res //{...values, id:this.insertId, dayTotals:{}, transaction_type: this.transType }			//HAS to include response for correct ID
					});
					this.setState({ entry: res });
					return false;
				} else if (res.validationErrors) {
					console.log('validationErrors ', res.validationErrors);
					throw new SubmissionError(res.validationErrors);
				} else {
					Alert.alert('Save failed, error ' + res.error + ' ' + res.status);
					throw new SubmissionError(res.error);
				}
			});
		}
	}

	itemEditClosed(item) {
		var { items } = this.props.formVals;

		__DEV__ && console.log('onSubmit itemform = ', item, items);
		//the one we're editing is this.state.editingItem
		//update or add the item ??

		//recalc total in case we didn't catch the blur/validate
		var total = Number(item.qty) * Number(item.unit);
		item.total = parseFloat(isNaN(total) ? 0 : total).toFixed(2);

		if (item.adding) {
			console.log('ADDING new item', item);
			delete item.adding;
			if (item.total == 0 && !item.description) {
				this.setState({ editingItem: false });
				return true;
			}
			//items.push(item)
			//this._changeFormVal('items', items)
			this.props.dispatch(arrayPush('InvoiceForm', 'items', item));
		} else {
			const otherItems = _.remove(items, this.state.editingItem);
			items.push(item); //id will be the same
			this._changeFormVal('items', items);
		}
		//recalc total
		this.recalcTotals();
		this.setState({ editingItem: false });
	}

	onDeleteTrans(item) {
		this.props.deleteTrans({
			expenseDate: item.expenseDate,
			real_id: item.id,
			transaction_type: 'receipt'
		});
	}

	setCust(id) {
		__DEV__ && console.log('set cust', id);
		this.setState({ entry: { ...this.state.entry, customer_id: id.toString() } });
	}

	render() {
		//if(!this.state.entry) return (<Spinner />);
		//console.log('RENDER INVOICE CONT', this.props);
		const { isSaving, isSharing, entry, adding } = this.state;
		__DEV__ && console.log('Render. vatReg', this.props.vatReg, ' saving', isSaving, this.props);

		this.readOnly = !entry || entry.invoice_status != 'draft' || (this.props.formVals.invoice_status && this.props.formVals.invoice_status != 'draft');
		const savable = (!this.readOnly && entry.customer_id) || (entry && entry.customer_id && this.props.formVals && this.props.formVals.invoice_status != entry.invoice_status);

		if (this.state.isError) {
			return (
				<Container>
					<Header>
						<Left>
							<Button transparent onPress={() => this.props.navigation.goBack()}>
								<Icon name="close" />
							</Button>
						</Left>
						<Text style={{ color: 'red' }}>Error loading transaction!</Text>
					</Header>
				</Container>
			);
		} else {
			return (
				<Container>
					{!isSaving && !isSharing ? (
						<Header>
							<Left>
								<Button transparent onPress={() => this.props.navigation.goBack()}>
									<Icon name={savable ? 'close' : 'ios-arrow-back'} />
								</Button>
							</Left>

							<Body style={{ flex: 3 }}>
								<Title>
									{adding ? 'Add' : ''} {!!entry && entry.description ? entry.description : this.state.type}
								</Title>
							</Body>

							<Right>
								{savable && (
									<Button transparent onPress={() => this.saveRecord()}>
										<Icon name="checkmark" />
									</Button>
								)}
							</Right>
						</Header>
					) : (
						<Header>
							<Body style={{ flex: 3 }}>
								<Title>Saving...</Title>
							</Body>

							<Right>
								<Spinner />
							</Right>
						</Header>
					)}
					{!!entry && entry.customer_id && (
						<InvoiceForm
							customers={this.props.customers}
							accounts={this.props.accounts}
							vatReg={this.props.vatReg}
							vatRate={this.props.vatRate}
							vatRates={this.props.vatRates}
							categories={this.props.takingCategories}
							initialValues={entry}
							navigation={this.props.navigation}
							showAccts={this.props.formVals.paid && this.props.formVals.paid > 0}
							onSubmit={this.handleSubmit.bind(this)}
							disabled={this.readOnly}
							openItem={item => this.openItem(item)}
							onAddItem={l => this.onAddItem(l)}
							editCustomer={id => this.editCustomer(id)}
							reCalc={() => this.recalcTotals()}
							status={this.props.formVals && this.props.formVals.invoice_status}
							type={this.state.type}
							ref="form"
						/>
					)}
					{!!this.state.editingCust && (
						<PersonForm
							closure={id => {
								this._personEditClosed(id);
							}}
							personType={'customer'}
							id={this.state.editingCust}
						/>
					)}
					{!!this.state.editingItem && (
						<InvoiceItemForm
							onSubmit={vals => {
								this.itemEditClosed(vals);
							}}
							initialValues={this.state.editingItem}
							servicesOnly={this.props.servicesOnly}
							itemRefs={this.props.invoiceItemRefs}
							changeServicesOnly={on => this.changeServicesOnly(on)}
							vatRates={this.props.vatRates}
							vatReg={this.props.vatReg}
							type={this.state.type}
							cancel={() => this.setState({ editingItem: false })}
						/>
					)}
					{!!entry && entry.customer_id && (
						<Footer style={styles.footer}>
							<Left>
								<Button style={styles.bottomButton} disabled={isSharing} onPress={() => this.download()}>
									<Icon name="download" active={isSharing} style={styles.bottomIcon} />
								</Button>
							</Left>
							<Body />
							<Right>
								<Button style={styles.bottomButton} disabled={isSharing} onPress={() => this.share()}>
									<Icon name="send" active={isSharing} style={styles.bottomIcon} />
								</Button>
							</Right>
						</Footer>
					)}
					{adding && !entry.customer_id && <CustomerSelect setCust={id => this.setCust(id)} customers={this.props.customers} />}
					<KeyHandler plus={() => this.onAddItem()} enter={() => savable && this.saveRecord()} esc={() => this.props.navigation.goBack()} />
				</Container>
			);
		}
	}

	changeServicesOnly(on) {
		//turn it on for the session ??
		//this.props.dispatch({ type: 'UPDATE/busDetails', difference: { servicesOnly: on } });
		//turn it on for the invoice
		this._changeFormVal('invoice_servicesOnly', on);
	}

	/** Cust editing **/
	editCustomer(id) {
		this.setState({ editingCust: id });
	}

	_personEditClosed(id) {
		//what?
		this.setState({ editingCust: false });
	}

	/***** Item editing *****/

	_changeFormVal(field, val) {
		__DEV__ && console.log('setting ', field, val);
		this.props.dispatch(change('InvoiceForm', field, val));
		//this.props.dispatch(change('InvoiceForm', 'description', 'TEST'));
	}

	openItem(item) {
		if (this.readOnly) return true;
		this.setState({ editingItem: item });
	}

	onAddItem(labour = false) {
		//console.log(this.props);
		//pop up item modal, new thingy
		if (!labour) {
			this.setState({
				editingItem: {
					qty: this.state.type == 'Invoice' ? '1' : '-1',
					unit: '0.00',
					vatrate: this.props.vatReg && this.props.vatRate.toString(),
					total: '0.00',
					adding: true,
					discount: '0.00'
				}
			});
		} else {
			this.setState({
				editingItem: {
					qty: this.state.type == 'Invoice' ? '1' : '-1',
					unit: '0.00',
					unitname: 'Hour',
					ref: 'Labour',
					vatrate: this.props.vatReg && this.props.vatRate.toString(),
					total: '0.00',
					adding: true,
					discount: '0.00'
				}
			});
		}
	}

	recalcTotals() {
		var { items } = this.props.formVals;
		const { vatReg } = this.props;
		var totNet = 0;
		var totForVat = [];
		_.forEach(items, function (item) {
			totNet += parseFloat(Number(item.total) - Number(item.discount));
			var rate = Number(item.vatrate).toFixed(1);
			if (vatReg) {
				if (!totForVat[rate]) totForVat[rate] = 0;
				totForVat[rate] += parseFloat(Number(item.total) - Number(item.discount));
			}
		});
		var totVat = 0;
		if (vatReg) {
			for (var k in totForVat) {
				if (totForVat[k]) totVat += (totForVat[k] * parseFloat(k)) / 100;
			}
		}

		//console.log(`setting totals vat ${totVat} net ${totNet}`);
		this._changeFormVal('vat', totVat.toFixed(2));
		this._changeFormVal('net', totNet.toFixed(2));
		this._changeFormVal('payable', (totNet + totVat).toFixed(2));
	}
}

const selector = formValueSelector('InvoiceForm');

function bindAction(dispatch) {
	return {
		deleteTrans: item => dispatch(deleteTrans(item)),
		dispatch
	};
}

const mapStateToProps = state => ({
	customers: state.globalReducer.customers,
	accounts: state.globalReducer.accounts,
	vatReg: state.globalReducer.busDetails.vatRegistered,
	vatRate: state.globalReducer.busDetails.vatRate,
	vatRates: state.globalReducer.vatRates,
	servicesOnly: state.globalReducer.busDetails.servicesOnly,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token,
	takingCategories: state.globalReducer.takingCategories,
	invoiceItemRefs: state.globalReducer.invoiceItems,
	formVals: selector(state, 'paid', 'items', 'invoice_status')
});

export default connect(mapStateToProps, bindAction)(InvoiceFormContainer);
